<template>
    <div class="container mail">
        
        <nav class="level" style="margin-bottom: 48px">
            <div class="level-left">
                <div class="level-item">
                    <b-input v-model="filter" placeholder="Søk" type="search" icon="search" style="margin-left:auto"></b-input>
                </div>                
            </div>            
        </nav>


        <div class="columns" v-for="(branch, index) in filtered" v-bind:key="index">
            <email-card :branch="branch"></email-card>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EmailCard from '@/components/EmailCard.vue'

export default {
    data () {
        return {
            filter: ''
        }
    }, 
    components: {
        EmailCard
    },
    computed: {
        ...mapGetters('emailreports', ['customers', 'exportFormats']),
        ...mapGetters('reporttypes', ['reportTypes']),
        filtered: function() {
            const filtered = this.customers.filter(customer => Object.keys(customer).some(k => customer[k].toString().toLowerCase().includes(this.filter.toLowerCase())))
            return filtered;
        }
    },
    methods: {
        ...mapActions('emailreports', ['getCustomers', 'getExportFormats']),
        ...mapActions('reporttypes', ['getReportTypes'])
    },
    mounted () {
        this.getCustomers()
        this.getExportFormats()
        this.getReportTypes()
    }
}
</script>

<style lang="scss" scoped>
div.mail {
    margin-top:32px;
}
</style>

